import React from "react";
import { PieChartOutlineRounded, ShowChart } from "@mui/icons-material";
import { motion } from "framer-motion";
import SlideBox from "../versatile/SlideBox";
import AboutCardMatrix from "../AboutCardMatrix";
import { useStateContext } from "../../contexts/ContextProvider"; // Adjust the path based on the file location

const Tools = () => {
  const { aboutToolsSlide } = useStateContext(); // Access the global slide state

  const data = [
    {
      headline: "Holders Structure Info",
      icon: <PieChartOutlineRounded fontSize="large" />,
      paragraphs: [
        "Realtime check what is going on with holders. Do new wallets jump in or old ones go out...",
        "Track real-time wallet activities for deeper insights into holder behaviors.",
      ],
    },
    {
      headline: "Price Action Breakdown",
      icon: <ShowChart fontSize="large" />,
      paragraphs: [
        "Gain insights in what made price move.",
        "Detect cheap moves, volume bot's percentage in price action for given frame.",
      ],
    },
  ];

  const texts0 = [
    `> What is this tool?  
    This tool is designed to analyze coin holders and provide insights into the distribution of top holders.
    
> Why is it useful?  
It shows the amount of unrealized profit or new in the token.
    
> How does sell reflect on visualization?  
If a top holder bought 3 times then sold, tokens sold are subtracted from each position in a relative manner.`,
  ];

  const texts1 = [
    `> It is like trying to find out are you watching good movie or a shitshow...
    
> Why is it useful?  
You can see if coin price action boards new holders or if the group running the coin is just pushing alone.  
    
> Example: Coin pumps 70% in given time frame?  
Volume can come from volume bots, fresh exchange funded wallets, old holders and many more options... This ansvers who bought/sold.`,
  ];

  return (
    <motion.div
      style={{
        gridColumn: "3 / span 12",
        gridRow: "5 / span 14",
        height: "100%", // Make the div take the full height of the parent container
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
      }}
    >
      <div
        style={{
          flex: 1,
          marginRight: "1rem",
          position: "relative",
          paddingTop: window.innerWidth < 1600 && window.innerHeight < 900 ? "0.5rem" : "1rem",
        }}
      >
        <SlideBox data={data} />
      </div>
      <div
        
        style={{
          flex: 2,
          paddingTop: window.innerWidth < 1600 && window.innerHeight < 900 ? "0.5rem" : "1rem",
        }}
      >
        {/* Dynamically show text based on the current slide */}
        <AboutCardMatrix texts={aboutToolsSlide === 0 ? texts0 : texts1} speed={100} key={aboutToolsSlide} />
      </div>
    </motion.div>
  );
};

export default Tools;
